module.exports = __webpack_public_path__ + "static/img/menu2.c386f5b2.png";